import { ApiRoomRequest, RoomContextState } from '@/RoomContext'
import { useTranslation } from 'react-i18next'
import { useUnlockProHandler } from './useUnlockProHandler'
import { Checkbox } from '@/UIComponents2/Checkbox'
import { cn } from '@/utlis/cn'

type SessionTypeInputProps = {
    permanent: boolean
    camp: boolean
    livestream: boolean
    permanentLocked?: boolean
    campLocked?: boolean
    livestreamLocked?: boolean
    disabled?: boolean
    onChange: (
        permanent: boolean,
        camp: boolean,
        livestream: boolean,
        roomApiDiff: Partial<ApiRoomRequest>,
        roomContextDiff: Partial<RoomContextState>
    ) => void
    className?: string
}
export function SessionTypeInput(props: SessionTypeInputProps) {
    const { t } = useTranslation()

    const handleChange = (permanent: boolean, camp: boolean, livestream: boolean) => {
        props.onChange(
            permanent,
            camp,
            livestream,
            mapSessionKindToApiDiff(permanent, camp, livestream),
            mapSessionKindToRoomContextDiff(permanent, camp, livestream)
        )
    }

    const handleProUpgrade = useUnlockProHandler()

    return (
        <div className={cn('grid grid-1 gap-4', props.className)}>
            <Checkbox
                label={t('Permanent Room')}
                locked={props.permanentLocked ?? false}
                checked={props.permanent}
                onClick={() => props.permanentLocked && handleProUpgrade('premiumFeature:permanentRoom')}
                disabled={props.disabled}
                onChange={(v) => handleChange(v, props.camp, props.livestream)}
            />
            <Checkbox
                label={t('Songwriting Camp')}
                locked={props.campLocked ?? false}
                onClick={() => props.campLocked && handleProUpgrade('premiumFeature:museCamp')}
                disabled={props.disabled}
                checked={props.camp}
                onChange={(v) => handleChange(props.permanent, v, props.livestream)}
            />
            <Checkbox
                label={t('Livestream')}
                locked={props.livestreamLocked ?? false}
                onClick={() => props.livestreamLocked && handleProUpgrade('premiumFeature:livestream')}
                disabled={props.disabled}
                checked={props.livestream}
                onChange={(v) => handleChange(props.permanent, props.camp, v)}
            />
            <Checkbox
                label={t('Realtime Jamming')}
                locked={true}
                onClick={() => handleProUpgrade('premiumFeature:realtimeSession')}
                checked={false}
                onChange={(v) => {}}
            />
        </div>
    )
}

function mapSessionKindToApiDiff(permanent: boolean, camp: boolean, livestream: boolean): Partial<ApiRoomRequest> {
    const patch: Partial<ApiRoomRequest> = {
        permanent: permanent,
        isSubroomsEnabled: camp,
        isListeningSession: livestream,
    }
    if (!permanent) {
        patch.resetAfterSession = false
    }
    return patch
}

function mapSessionKindToRoomContextDiff(
    permanent: boolean,
    camp: boolean,
    livestream: boolean
): Partial<RoomContextState> {
    const patch: Partial<RoomContextState> = {
        permanent,
        isSubroomsEnabled: camp,
        isListeningSession: livestream,
    }
    if (!permanent) {
        patch.resetAfterSession = false
    }
    return patch
}
